module.exports = __webpack_public_path__ + "img/favicon_white.009548fa.png";